<template>
    <div class="search-result__text">
        <a :href="result.href" class="text--link" @click="openLink">
            <h3 class="text--title" v-html="highlightedTitle"></h3>
            <p class="text--abstract" v-html="highlightedAbstract"></p>
        </a>
    </div>
</template>

<script>
    import constants from "@search/shared/constants";

	export default {
        name: "search-result-text",
        props: {
            result: {
                type: Object,
                default: function () {
                    return {
                        href: "#",
                        title: "You have so many different things placeholder",
                        abstract: "My placeholder text, I think, is going to end up being very good with women. Trump Ipsum is calling for a total and complete shutdown of Muslim text entering your website. When other websites give you text, they’re not sending the best. They’re not sending you, they’re sending words that have lots of problems and they’re bringing those problems with us. They’re bringing mistakes. They’re bringing misspellings."
                    }
                }
            }
        },
        computed: {
            highlightedAbstract() {
                return this.result.abstract.replace(new RegExp(`(${this.$store.getters.keyword})`,'gi'), '<strong>$&</strong>');
            },
            highlightedTitle() {
                return this.result.title.replace(new RegExp(`(${this.$store.getters.keyword})`,'gi'), '<span class="underline">$&</span>');
            }
        },
		methods: {
			openLink() {
				const scrollOffset = Math.floor(window.pageYOffset); // Damit da kein 2160.23452534532 rauskommt....

				if (this.$store.state.category !== constants.resultKind.all) {
					const activeCat = this.$store.getters.searchResultsForKind(this.$store.state.category);

					// Offset muss hier reduziert werden, da results.length schon das Offset für eine Seite mehr wäre
					const offset = Math.max(activeCat.results.length - constants.resultsPerPage, 0);

					// for history back
					const scrolledUrl = window.location.pathname+'?tx_salbase9_search[q]=' + this.$store.state.keyword + '&tx_salbase9_search[cat]=' + this.$store.state.category + '#' + offset + ',' + scrollOffset;
					// console.log('replacing history with', scrolledUrl);
					history.replaceState({}, '', scrolledUrl);
				}
				else {
					// for history back
					const scrolledUrl = window.location.pathname+'?tx_salbase9_search[q]=' + this.$store.state.keyword + '#0,'+scrollOffset;
					// console.log('replacing history with', scrolledUrl);
					history.replaceState({}, '', scrolledUrl);
				}
			}
		}
    }
</script>
